// import sanitize from 'sanitize-html';
// import * as sanitizeHtml from 'sanitize-html';

import util from './util';
import defaultFontConfig from '../assets/config/default-font-config.json';

class styleConfigHelper {
    constructor() {
        if (!styleConfigHelper.instance) {
            styleConfigHelper.instance = this;
            this.defaultFont = defaultFontConfig;
        }

        return styleConfigHelper.instance;
    }

    isColor = (strColor) => {
        const s = new Option().style;
        s.color = strColor;
        return s.color !== '';
    };

    //Update legend and draw sort on new style config
    updateConfig = (config) => {
        let objList = [];
        let that = this;
        if (Array.isArray(config)) {
            config?.forEach(function (item) {
                item = that.checkAttribute(item);

                objList.push(item);
            });
        }

        const utilFunc = new util();

        objList.sort(utilFunc.legendSort());

        for (let index = 0; index < objList.length; index++) {
            objList[index].LegendSort = index;
        }

        objList.sort(utilFunc.drawSort());

        for (let index = 0; index < objList.length; index++) {
            objList[index].DrawSort = index;
        }

        this._symbolConfig = objList;
    };

    defaultColourData = () => {
        return {
            LegendSort: 100,
            DrawSort: 100,
            FillCol: '#8B0000',
            OutlineCol: '#fff',
            TextCol: '#fff',
            HasDash: false
        };
    };

    checkAttribute = (item) => {
        if (!item) item = {};

        if (!this.hasProperty(item, 'LegendSort')) item.LegendSort = 10000;

        if (!this.hasProperty(item, 'DrawSort')) item.DrawSort = 10000;

        if (!this.hasProperty(item, 'FillCol')) item.FillCol = this.defaultColourData.TextCol;
        else {
            if (this.isColor(item.FillCol)) item.FillCol = this.safeCss(item.FillCol);
            else item.FillCol = this.defaultColourData.TextCol;
        }

        if (!this.hasProperty(item, 'OutlineCol')) item.OutlineCol = this.defaultColourData.OutlineCol;
        else item.OutlineCol = this.safeCss(item.OutlineCol);

        if (!this.hasProperty(item, 'TextCol')) item.TextCol = this.defaultColourData.TextCol;
        else item.textCol = this.safeCss(item.TextCol);

        return item;
    };

    /* return the colors from the config, if not found return default color */
    getColourData = (discriminator) => {
        let result;

        if (Array.isArray(this._symbolConfig) && discriminator) {
            result = this._symbolConfig.find((e) => e.Discriminator == discriminator);
            if (result) return result;
        }

        return this.defaultColourData();
    };

    getColourForCluster = (discriminator) => {
        let color = this.getColourData(discriminator);
        color.FillCol = this.safeCss(color.FillCol);
        return color;
    };

    safeCss = (data) => {
        return data;
        // return sanitizeHtml(data);
    };

    hasProperty = (object, value) => {
        return Object.prototype.hasOwnProperty.call(object, value);
    };
}

export default styleConfigHelper;
